import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query"

import { deleteUsuario } from "../services/usuario.service";

import { successNotification, dangerNotification } from '../../../../../../redux/slices/ui';

export const useEliminar = () => {

    const dispatch = useDispatch();

    const eliminarMutation = useMutation({
        mutationFn: deleteUsuario,
        onSuccess: (usuario, variables, context) => {
            dispatch(successNotification('Cuenta cancelada'));
            variables.onSuccess();
        },
        onError: (error, variables, context) => {
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        eliminarMutation,
    }
}